import { useQuery } from "@tanstack/react-query";
import { fetchStoryInvitees } from "../services/storyInvitees/storyInviteesApi";
import { queryKeys } from "../services/queryKeys";

/** Full invite lifecycle for a story, used to populate ShareStoryModal's current-members list. */
export const useStoryInvitees = (storyId: string, enabled = true) =>
  useQuery({
    queryKey: queryKeys.storyInvitees.list(storyId),
    queryFn: () => fetchStoryInvitees(storyId),
    enabled: enabled && Boolean(storyId),
  });
